import CustomMultiSelect from "common/components/MultiSelect"
import {
  defaultItemTemplate,
  defaultPanelFooterTemplate,
  defaultSelectedItemTemplate,
} from "common/components/MultiSelect/templates"
import { useState } from "react"

const EtiquetasMultiSelect = ({
  options = [],
  value,
  onChange,
  className = "",
  canAddOption = false,
}: $TSMigrationFixMe) => {
  const [openCreateModal, setOpenCreateModal] = useState(false)

  const toogleCreateModal = () => {
    setOpenCreateModal(!openCreateModal)
  }

  const props = {
    className,
    value,
    options,
    onChange,
    itemTemplate: defaultItemTemplate,
    selectedItemTemplate: defaultSelectedItemTemplate,
    ...(canAddOption && {
      openCreateModal,
      toogleCreateModal,
      panelFooterTemplate: defaultPanelFooterTemplate(toogleCreateModal),
    }),
  }

  return <CustomMultiSelect {...props} />
}

export default EtiquetasMultiSelect
